<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(255, 0, 0, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="10">
                    <input type="text" v-model="searchValue" placeholder="Kode Jam Kerja" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="2">
                    <CButton @click="goSetting()" type="button" class="btn btn-add">Setting</CButton>
                </CCol>
                <CCol sm="2"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Dialogs ref="dialog" @save="goSaveSetting"/>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <template>
            <CRow class="area-back">
                <CCol sm="12">
                    <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
                </CCol>
            </CRow>
            <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
            <CRow class="area-input">
                <CCol sm="12">
                    <CRow>
                        <CCol sm="6">
                            <label>Deskripsi Jam Kerja</label>
                            <input 
                                class="form-control mr-2" 
                                v-model.trim="$v.deskripsi.$model"
                                :class="{ 'is-invalid':$v.deskripsi.$error, 'is-valid': !$v.deskripsi.$invalid }"
                                placeholder="Deskripsi Jam Kerja" 
                                type="text"
                            />
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CRow class="area-input">
                <CCol sm="12">
                    <CRow>
                        <CCol sm="6">
                            <label class="font-weight-bold text-primary">Hari : Senin</label>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Kerja</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.jamMasukSenin.$model"
                                :class="{ 'is-invalid':$v.jamMasukSenin.$error, 'is-valid': !$v.jamMasukSenin.$invalid }"
                                placeholder="Jam Mulai Kerja"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Kerja</label>
                            <input 
                                class="form-control"
                                v-model.trim="$v.jamKeluarSenin.$model"
                                :class="{ 'is-invalid':$v.jamKeluarSenin.$error, 'is-valid': !$v.jamKeluarSenin.$invalid }"
                                placeholder="Jam Selesai Kerja"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Istirahat</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.istirahatKeluarSenin.$model"
                                :class="{ 'is-invalid':$v.istirahatKeluarSenin.$error, 'is-valid': !$v.istirahatKeluarSenin.$invalid }"
                                placeholder="Jam Mulai Istirahat"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Istirahat</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.istirahatMasukSenin.$model"
                                :class="{ 'is-invalid':$v.istirahatMasukSenin.$error, 'is-valid': !$v.istirahatMasukSenin.$invalid }"
                                placeholder="Jam Selesai Istirahat"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CRow class="area-input">
                <CCol sm="12">
                    <CRow>
                        <CCol sm="6">
                            <label class="font-weight-bold text-primary">Hari : Selasa</label>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Kerja</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.jamMasukSelasa.$model"
                                :class="{ 'is-invalid':$v.jamMasukSelasa.$error, 'is-valid': !$v.jamMasukSelasa.$invalid }"
                                placeholder="Jam Mulai Kerja"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Kerja</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.jamKeluarSelasa.$model"
                                :class="{ 'is-invalid':$v.jamKeluarSelasa.$error, 'is-valid': !$v.jamKeluarSelasa.$invalid }"
                                placeholder="Jam Selesai Kerja"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Istirahat</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.istirahatKeluarSelasa.$model"
                                :class="{ 'is-invalid':$v.istirahatKeluarSelasa.$error, 'is-valid': !$v.istirahatKeluarSelasa.$invalid }"
                                placeholder="Jam Mulai Istirahat"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Istirahat</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.istirahatMasukSelasa.$model"
                                :class="{ 'is-invalid':$v.istirahatMasukSelasa.$error, 'is-valid': !$v.istirahatMasukSelasa.$invalid }"
                                placeholder="Jam Selesai Istirahat"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CRow class="area-input">
                <CCol sm="12">
                    <CRow>
                        <CCol sm="6">
                            <label class="font-weight-bold text-primary">Hari : Rabu</label>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Kerja</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.jamMasukRabu.$model"
                                :class="{ 'is-invalid':$v.jamMasukRabu.$error, 'is-valid': !$v.jamMasukRabu.$invalid }"
                                placeholder="Jam Mulai Kerja"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Kerja</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.jamKeluarRabu.$model"
                                :class="{ 'is-invalid':$v.jamKeluarRabu.$error, 'is-valid': !$v.jamKeluarRabu.$invalid }"
                                placeholder="Jam Selesai Kerja"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Istirahat</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.istirahatKeluarRabu.$model"
                                :class="{ 'is-invalid':$v.istirahatKeluarRabu.$error, 'is-valid': !$v.istirahatKeluarRabu.$invalid }"
                                placeholder="Jam Mulai Istirahat"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Istirahat</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.istirahatMasukRabu.$model"
                                :class="{ 'is-invalid':$v.istirahatMasukRabu.$error, 'is-valid': !$v.istirahatMasukRabu.$invalid }"
                                placeholder="Jam Selesai Istirahat"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CRow class="area-input">
                <CCol sm="12">
                    <CRow>
                        <CCol sm="6">
                            <label class="font-weight-bold text-primary">Hari : Kamis</label>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Kerja</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.jamMasukKamis.$model"
                                :class="{ 'is-invalid':$v.jamMasukKamis.$error, 'is-valid': !$v.jamMasukKamis.$invalid }"
                                placeholder="Jam Mulai Kerja"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Kerja</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.jamKeluarKamis.$model"
                                :class="{ 'is-invalid':$v.jamKeluarKamis.$error, 'is-valid': !$v.jamKeluarKamis.$invalid }"
                                placeholder="Jam Selesai Kerja"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Istirahat</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.istirahatKeluarKamis.$model"
                                :class="{ 'is-invalid':$v.istirahatKeluarKamis.$error, 'is-valid': !$v.istirahatKeluarKamis.$invalid }"
                                placeholder="Jam Mulai Istirahat"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Istirahat</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.istirahatMasukKamis.$model"
                                :class="{ 'is-invalid':$v.istirahatMasukKamis.$error, 'is-valid': !$v.istirahatMasukKamis.$invalid }"
                                placeholder="Jam Selesai Istirahat"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CRow class="area-input">
                <CCol sm="12">
                    <CRow>
                        <CCol sm="6">
                            <label class="font-weight-bold text-primary">Hari : Jumat</label>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Kerja</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.jamMasukJumat.$model"
                                :class="{ 'is-invalid':$v.jamMasukJumat.$error, 'is-valid': !$v.jamMasukJumat.$invalid }"
                                placeholder="Jam Mulai Kerja"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Kerja</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.jamKeluarJumat.$model"
                                :class="{ 'is-invalid':$v.jamKeluarJumat.$error, 'is-valid': !$v.jamKeluarJumat.$invalid }"
                                placeholder="Jam Selesai Kerja"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Istirahat</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.istirahatKeluarJumat.$model"
                                :class="{ 'is-invalid':$v.istirahatKeluarJumat.$error, 'is-valid': !$v.istirahatKeluarJumat.$invalid }"
                                placeholder="Jam Mulai Istirahat"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Istirahat</label>
                            <input 
                                class="form-control" 
                                v-model.trim="$v.istirahatMasukJumat.$model"
                                :class="{ 'is-invalid':$v.istirahatMasukJumat.$error, 'is-valid': !$v.istirahatMasukJumat.$invalid }"
                                placeholder="Jam Selesai Istirahat"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CRow class="area-input">
                <CCol sm="12">
                    <CRow>
                        <CCol sm="6">
                            <CRow>
                                <CCol sm="6">
                                    <label class="font-weight-bold text-primary">Hari : Sabtu</label>
                                </CCol>
                                <CCol sm="6">
                                    <div>
                                        <input type="checkbox" id="sabtu" @change="saturday()" :checked="checkSabtu == 1">
                                        <label for="sabtu">Input Hari Sabtu</label>
                                    </div>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Kerja</label>
                            <input 
                                :disabled="disSabtu == true"
                                class="form-control" 
                                v-model="jamMasukSabtu"
                                placeholder="Jam Mulai Kerja"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Kerja</label>
                            <input 
                                :disabled="disSabtu == true"
                                class="form-control" 
                                v-model="jamKeluarSabtu"
                                placeholder="Jam Selesai Kerja"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Istirahat</label>
                            <input 
                                :disabled="disSabtu == true"
                                class="form-control" 
                                v-model="istirahatKeluarSabtu"
                                placeholder="Jam Mulai Istirahat"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Istirahat</label>
                            <input 
                                :disabled="disSabtu == true"
                                class="form-control" 
                                v-model="istirahatMasukSabtu"
                                placeholder="Jam Selesai Istirahat"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CRow class="area-input">
                <CCol sm="12">
                    <CRow>
                        <CCol sm="6">
                            <CRow>
                                <CCol sm="6">
                                    <label class="font-weight-bold text-primary">Hari : Minggu</label>
                                </CCol>
                                <CCol sm="6">
                                    <div>
                                        <input type="checkbox" id="minggu" @change="sunday()" :checked="checkMinggu == 1">
                                        <label for="minggu">Input Hari Minggu</label>
                                    </div>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Kerja</label>
                            <input 
                                :disabled="disMinggu == true"
                                class="form-control" 
                                v-model="jamMasukMinggu"
                                placeholder="Jam Mulai Kerja"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Kerja</label>
                            <input 
                                :disabled="disMinggu == true"
                                class="form-control" 
                                v-model="jamKeluarMinggu"
                                placeholder="Jam Selesai Kerja"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label>Jam Mulai Istirahat</label>
                            <input 
                                :disabled="disMinggu == true"
                                class="form-control" 
                                v-model="istirahatKeluarMinggu"
                                placeholder="Jam Mulai Istirahat"
                                type="time"
                            />
                        </CCol>
                        <CCol sm="6">
                            <label>Jam Selesai Istirahat</label>
                            <input 
                                :disabled="disMinggu == true"
                                class="form-control" 
                                v-model="istirahatMasukMinggu"
                                placeholder="Jam Selesai Istirahat"
                                type="time"
                            />
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CRow class="area-button-submit">
                <CCol sm="12">
                    <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                    <CButton @click="submitForm()" class="btn btn-edit-submit">
                        <span v-if="loading == false">Submit</span>
                        <CSpinner v-else color="default" size="sm"/>
                    </CButton>
                </CCol>
            </CRow>
        </template>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tables'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import Dialogs from '../../../component/DialogJamKerja'
export default {
    components: {
        ModelSelect,
        Tables,
        Dialogs
    },
    mixins: [validationMixin],
    validations: {
        deskripsi: {
            required
        },
        jamMasukSenin: {
            required
        },
        jamKeluarSenin: {
            required
        },
        istirahatMasukSenin: {
            required
        },
        istirahatKeluarSenin: {
            required
        },
        jamMasukSelasa: {
            required
        },
        jamKeluarSelasa: {
            required
        },
        istirahatMasukSelasa: {
            required
        },
        istirahatKeluarSelasa: {
            required
        },
        jamMasukRabu: {
            required
        },
        jamKeluarRabu: {
            required
        },
        istirahatMasukRabu: {
            required
        },
        istirahatKeluarRabu: {
            required
        },
        jamMasukKamis: {
            required
        },
        jamKeluarKamis: {
            required
        },
        istirahatMasukKamis: {
            required
        },
        istirahatKeluarKamis: {
            required
        },
        jamMasukJumat: {
            required
        },
        jamKeluarJumat: {
            required
        },
        istirahatMasukJumat: {
            required
        },
        istirahatKeluarJumat: {
            required
        },
    },
    data() {
        return {
            disSabtu: true,
            disMinggu: true,
            success: true,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            dataTh: ['Kode', 'Deskripsi', 'Action'],
            dataTd: ['kode', 'deskripsi', 'action'],
            styleTable: ['75px', '100px', '75px', '100px', '100px', '150px', '150px', '80px'],
            classReload: 'reloadOff',
            datas: [],
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,
            constDay: 1,
            editSession: false,

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // data model
            kode: '',
            deskripsi: '',
            jamMasukSenin: '',
            jamKeluarSenin: '',
            istirahatMasukSenin: '',
            istirahatKeluarSenin: '',
            jamMasukSelasa: '',
            jamKeluarSelasa: '',
            istirahatMasukSelasa: '',
            istirahatKeluarSelasa: '',
            jamMasukRabu: '',
            jamKeluarRabu: '',
            istirahatMasukRabu: '',
            istirahatKeluarRabu: '',
            jamMasukKamis: '',
            jamKeluarKamis: '',
            istirahatMasukKamis: '',
            istirahatKeluarKamis: '',
            jamMasukJumat: '',
            jamKeluarJumat: '',
            istirahatMasukJumat: '',
            istirahatKeluarJumat: '',
            jamMasukSabtu: '',
            jamKeluarSabtu: '',
            istirahatMasukSabtu: '',
            istirahatKeluarSabtu: '',
            jamMasukMinggu: '',
            jamKeluarMinggu: '',
            istirahatMasukMinggu: '',
            istirahatKeluarMinggu: '',
            unix: '',
            tipe: 'C',
            hari: '',
            unix1: '',
            unix2: '',
            unix3: '',
            unix4: '',
            unix5: '',
            unix6: '',
            unix7: '',
            istirahatKeluar: '00:00:00',
            istirahatMasuk: '00:00:00',
            kerjaKeluar: '00:00:00',
            kerjaMasuk: '00:00:00',
            checkSabtu: 0,
            checkMinggu: 0,

            // filter
            searchValue: '',

            // error
            errorMessage: '',
            flagSearch: false,

            // setting
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchValue() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    methods: {
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kode.toLowerCase() < b.kode.toLowerCase()) {
                        return -1
                    }
                    if (a.kode.toLowerCase() > b.kode.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.deskripsi.toLowerCase() < b.deskripsi.toLowerCase()) {
                        return -1
                    }
                    if (a.deskripsi.toLowerCase() > b.deskripsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.hari.toLowerCase() < b.hari.toLowerCase()) {
                        return -1
                    }
                    if (a.hari.toLowerCase() > b.hari.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.kerjaMasuk.toLowerCase() < b.kerjaMasuk.toLowerCase()) {
                        return -1
                    }
                    if (a.kerjaMasuk.toLowerCase() > b.kerjaMasuk.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.kerjaKeluar.toLowerCase() < b.kerjaKeluar.toLowerCase()) {
                        return -1
                    }
                    if (a.kerjaKeluar.toLowerCase() > b.kerjaKeluar.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.istirahatMasuk.toLowerCase() < b.istirahatMasuk.toLowerCase()) {
                        return -1
                    }
                    if (a.istirahatMasuk.toLowerCase() > b.istirahatMasuk.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.istirahatKeluar.toLowerCase() < b.istirahatKeluar.toLowerCase()) {
                        return -1
                    }
                    if (a.istirahatKeluar.toLowerCase() > b.istirahatKeluar.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            // let limit = this.size
            let kode = this.searchValue
            let page = this.page

            let payload = {
                limit: 99999,
                kode: kode,
                pageIn: page,
            }
            DataApi.post("jam_kerja/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let temp = response.data.data
                    var i = 0
                    let dataGet = []
                    for(i=0;i<temp.length;i++) {
                        if(dataGet.length == 0) {
                            let push = {
                                kode: temp[i].kode,
                                deskripsi: temp[i].deskripsi
                            }
                            dataGet.push(push)
                        } else {
                            var j = 0
                            let status = false
                            for(j=0;j<dataGet.length;j++) {
                                if(dataGet[j].kode == temp[i].kode) {
                                    status = false
                                    break
                                } else {
                                    status = true
                                }
                            }
                            if(status == true) {
                                let onPush = {
                                    kode: temp[i].kode,
                                    deskripsi: temp[i].deskripsi
                                }
                                dataGet.push(onPush)
                            }
                        }
                    }
                    this.datas = dataGet
                    this.totalRow = this.datas.length
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchValue = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 300);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.kode = ''
                this.deskripsi = ''
                this.jamMasukSenin = ''
                this.jamKeluarSenin = ''
                this.istirahatMasukSenin = ''
                this.istirahatKeluarSenin = ''
                this.jamMasukSelasa = ''
                this.jamKeluarSelasa = ''
                this.istirahatMasukSelasa = ''
                this.istirahatKeluarSelasa = ''
                this.jamMasukRabu = ''
                this.jamKeluarRabu = ''
                this.istirahatMasukRabu = ''
                this.istirahatKeluarRabu = ''
                this.jamMasukKamis = ''
                this.jamKeluarKamis = ''
                this.istirahatMasukKamis = ''
                this.istirahatKeluarKamis = ''
                this.jamMasukJumat = ''
                this.jamKeluarJumat = ''
                this.istirahatMasukJumat = ''
                this.istirahatKeluarJumat = ''
                this.jamMasukSabtu = ''
                this.jamKeluarSabtu = ''
                this.istirahatMasukSabtu = ''
                this.istirahatKeluarSabtu = ''
                this.jamMasukMinggu = ''
                this.jamKeluarMinggu = ''
                this.istirahatMasukMinggu = ''
                this.istirahatKeluarMinggu = ''
                this.unix = ''
                this.hari = ''
                this.istirahatKeluar = '00:00:00'
                this.istirahatMasuk = '00:00:00'
                this.kerjaKeluar = '00:00:00'
                this.kerjaMasuk = '00:00:00'
                this.goArea = true
                this.tipe = 'C'
                this.$v.$reset()
            }
        },
        goSave() {
            let kres = '#'
            let deskripsi = this.deskripsi
            let seninMasukKerja = ''
            let seninKeluarKerja = ''
            let seninMasukIstirahat = ''
            let seninKeluarIstirahat = ''
            let selasaMasukKerja = ''
            let selasaKeluarKerja = ''
            let selasaMasukIstirahat = ''
            let selasaKeluarIstirahat = ''
            let rabuMasukKerja = ''
            let rabuKeluarKerja = ''
            let rabuMasukIstirahat = ''
            let rabuKeluarIstirahat = ''
            let kamisMasukKerja = ''
            let kamisKeluarKerja = ''
            let kamisMasukIstirahat = ''
            let kamisKeluarIstirahat = ''
            let jumatMasukKerja = ''
            let jumatKeluarKerja = ''
            let jumatMasukIstirahat = ''
            let jumatKeluarIstirahat = ''
            let sabtuMasukKerja = ''
            let sabtuKeluarKerja = ''
            let sabtuMasukIstirahat = ''
            let sabtuKeluarIstirahat = ''
            let mingguMasukKerja = ''
            let mingguKeluarKerja = ''
            let mingguMasukIstirahat = ''
            let mingguKeluarIstirahat = ''
            if(this.jamMasukSenin.length == 5) {
                seninMasukKerja = this.jamMasukSenin + ':00'
            } else {
                seninMasukKerja = this.jamMasukSenin
            }
            if(this.jamKeluarSenin.length == 5) {
                seninKeluarKerja = this.jamKeluarSenin + ':00'
            } else {
                seninKeluarKerja = this.jamKeluarSenin
            }
            if(this.istirahatMasukSenin.length == 5) {
                seninMasukIstirahat = this.istirahatMasukSenin + ':00'
            } else {
                seninMasukIstirahat = this.istirahatMasukSenin
            }
            if(this.istirahatKeluarSenin.length == 5) {
                seninKeluarIstirahat = this.istirahatKeluarSenin + ':00'
            } else {
                seninKeluarIstirahat = this.istirahatKeluarSenin
            }

            if(this.jamMasukSelasa.length == 5) {
                selasaMasukKerja = this.jamMasukSelasa + ':00'
            } else {
                selasaMasukKerja = this.jamMasukSelasa
            }
            if(this.jamKeluarSelasa.length == 5) {
                selasaKeluarKerja = this.jamKeluarSelasa + ':00'
            } else {
                selasaKeluarKerja = this.jamKeluarSelasa
            }
            if(this.istirahatMasukSelasa.length == 5) {
                selasaMasukIstirahat = this.istirahatMasukSelasa + ':00'
            } else {
                selasaMasukIstirahat = this.istirahatMasukSelasa
            }
            if(this.istirahatKeluarSelasa.length == 5) {
                selasaKeluarIstirahat = this.istirahatKeluarSelasa + ':00'
            } else {
                selasaKeluarIstirahat = this.istirahatKeluarSelasa
            }

            if(this.jamMasukRabu.length == 5) {
                rabuMasukKerja = this.jamMasukRabu + ':00'
            } else {
                rabuMasukKerja = this.jamMasukRabu
            }
            if(this.jamKeluarRabu.length == 5) {
                rabuKeluarKerja = this.jamKeluarRabu + ':00'
            } else {
                rabuKeluarKerja = this.jamKeluarRabu
            }
            if(this.istirahatMasukRabu.length == 5) {
                rabuMasukIstirahat = this.istirahatMasukRabu + ':00'
            } else {
                rabuMasukIstirahat = this.istirahatMasukRabu
            }
            if(this.istirahatKeluarRabu.length == 5) {
                rabuKeluarIstirahat = this.istirahatKeluarRabu + ':00'
            } else {
                rabuKeluarIstirahat = this.istirahatKeluarRabu
            }

            if(this.jamMasukKamis.length == 5) {
                kamisMasukKerja = this.jamMasukKamis + ':00'
            } else {
                kamisMasukKerja = this.jamMasukKamis
            }
            if(this.jamKeluarKamis.length == 5) {
                kamisKeluarKerja = this.jamKeluarKamis + ':00'
            } else {
                kamisKeluarKerja = this.jamKeluarKamis
            }
            if(this.istirahatMasukKamis.length == 5) {
                kamisMasukIstirahat = this.istirahatMasukKamis + ':00'
            } else {
                kamisMasukIstirahat = this.istirahatMasukKamis
            }
            if(this.istirahatKeluarKamis.length == 5) {
                kamisKeluarIstirahat = this.istirahatKeluarKamis + ':00'
            } else {
                kamisKeluarIstirahat = this.istirahatKeluarKamis
            }

            if(this.jamMasukJumat.length == 5) {
                jumatMasukKerja = this.jamMasukJumat + ':00'
            } else {
                jumatMasukKerja = this.jamMasukJumat
            }
            if(this.jamKeluarJumat.length == 5) {
                jumatKeluarKerja = this.jamKeluarJumat + ':00'
            } else {
                jumatKeluarKerja = this.jamKeluarJumat
            }
            if(this.istirahatMasukJumat.length == 5) {
                jumatMasukIstirahat = this.istirahatMasukJumat + ':00'
            } else {
                jumatMasukIstirahat = this.istirahatMasukJumat
            }
            if(this.istirahatKeluarJumat.length == 5) {
                jumatKeluarIstirahat = this.istirahatKeluarJumat + ':00'
            } else {
                jumatKeluarIstirahat = this.istirahatKeluarJumat
            }

            if(this.jamMasukSabtu.length == 5) {
                sabtuMasukKerja = this.jamMasukSabtu + ':00'
            } else {
                sabtuMasukKerja = this.jamMasukSabtu
            }
            if(this.jamKeluarSabtu.length == 5) {
                sabtuKeluarKerja = this.jamKeluarSabtu + ':00'
            } else {
                sabtuKeluarKerja = this.jamKeluarSabtu
            }
            if(this.istirahatMasukSabtu.length == 5) {
                sabtuMasukIstirahat = this.istirahatMasukSabtu + ':00'
            } else {
                sabtuMasukIstirahat = this.istirahatMasukSabtu
            }
            if(this.istirahatKeluarSabtu.length == 5) {
                sabtuKeluarIstirahat = this.istirahatKeluarSabtu + ':00'
            } else {
                sabtuKeluarIstirahat = this.istirahatKeluarSabtu
            }

            if(this.jamMasukMinggu.length == 5) {
                mingguMasukKerja = this.jamMasukMinggu + ':00'
            } else {
                mingguMasukKerja = this.jamMasukMinggu
            }
            if(this.jamKeluarMinggu.length == 5) {
                mingguKeluarKerja = this.jamKeluarMinggu + ':00'
            } else {
                mingguKeluarKerja = this.jamKeluarMinggu
            }
            if(this.istirahatMasukMinggu.length == 5) {
                mingguMasukIstirahat = this.istirahatMasukMinggu + ':00'
            } else {
                mingguMasukIstirahat = this.istirahatMasukMinggu
            }
            if(this.istirahatKeluarMinggu.length == 5) {
                mingguKeluarIstirahat = this.istirahatKeluarMinggu + ':00'
            } else {
                mingguKeluarIstirahat = this.istirahatKeluarMinggu
            }
            let hari1 = '1' + kres + seninMasukKerja + kres + seninKeluarKerja + kres + seninMasukIstirahat + kres + seninKeluarIstirahat + kres + this.unix1
            let hari2 = '2' + kres + selasaMasukKerja + kres + selasaKeluarKerja + kres + selasaMasukIstirahat + kres + selasaKeluarIstirahat + kres + this.unix2
            let hari3 = '3' + kres + rabuMasukKerja + kres + rabuKeluarKerja + kres + rabuMasukIstirahat + kres + rabuKeluarIstirahat + kres + this.unix3
            let hari4 = '4' + kres + kamisMasukKerja + kres + kamisKeluarKerja + kres + kamisMasukIstirahat + kres + kamisKeluarIstirahat + kres + this.unix4
            let hari5 = '5' + kres + jumatMasukKerja + kres + jumatKeluarKerja + kres + jumatMasukIstirahat + kres + jumatKeluarIstirahat + kres + this.unix5

            let hari6 = ''
            let hari7 = ''
            if(this.disSabtu == true) {
                hari6 = ''
            } else {
                hari6 = '6' + kres + sabtuMasukKerja + kres + sabtuKeluarKerja + kres + sabtuMasukIstirahat + kres + sabtuKeluarIstirahat + kres + this.unix6
            }
            if(this.disMinggu == true) {
                hari7 = ''
            } else {
                hari7 = '7' + kres + mingguMasukKerja + kres + mingguKeluarKerja + kres + mingguMasukIstirahat + kres + mingguKeluarIstirahat + kres + this.unix7
            }
            
            let hari = ''
            let istirahatKeluar = ''
            let istirahatMasuk = ''
            let kerjaMasuk = ''
            let kerjaKeluar = ''
            let kode = this.kode
            let tipe = this.tipe

            

            let payload = {
                deskripsi: deskripsi,
                hari: hari,
                hari1: hari1,
                hari2: hari2,
                hari3: hari3,
                hari4: hari4,
                hari5: hari5,
                hari6: hari6,
                hari7: hari7,
                istirahatKeluar: istirahatKeluar,
                istirahatMasuk: istirahatMasuk,
                kerjaMasuk: kerjaMasuk,
                kerjaKeluar: kerjaKeluar,
                kode: kode,
                tipe: tipe,
                unix: 'null'
            }
            DataApi.post("jam_kerja/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            let kode = generate.kode
            this.deskripsi = generate.deskripsi
            this.tipe = 'U'
            let limit = this.size
            // let page = this.page

            let payload = {
                limit: limit,
                kode: kode,
                pageIn: 1,
            }
            DataApi.post("jam_kerja/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let temp = response.data.data
                    this.kode = temp[0].kode
                    var i = 0
                    for(i=0;i<temp.length;i++) {
                        if(temp[i].hari == '1') {
                            this.jamMasukSenin = temp[i].kerjaMasuk
                            this.jamKeluarSenin = temp[i].kerjaKeluar
                            this.istirahatMasukSenin = temp[i].istirahatMasuk
                            this.istirahatKeluarSenin = temp[i].istirahatKeluar
                            this.unix1 = temp[i].unix
                        } else if(temp[i].hari == '2') {
                            this.jamMasukSelasa = temp[i].kerjaMasuk
                            this.jamKeluarSelasa = temp[i].kerjaKeluar
                            this.istirahatMasukSelasa = temp[i].istirahatMasuk
                            this.istirahatKeluarSelasa = temp[i].istirahatKeluar
                            this.unix2 = temp[i].unix
                        } else if(temp[i].hari == '3') {
                            this.jamMasukRabu = temp[i].kerjaMasuk
                            this.jamKeluarRabu = temp[i].kerjaKeluar
                            this.istirahatMasukRabu = temp[i].istirahatMasuk
                            this.istirahatKeluarRabu = temp[i].istirahatKeluar
                            this.unix3 = temp[i].unix
                        }  else if(temp[i].hari == '4') {
                            this.jamMasukKamis = temp[i].kerjaMasuk
                            this.jamKeluarKamis = temp[i].kerjaKeluar
                            this.istirahatMasukKamis = temp[i].istirahatMasuk
                            this.istirahatKeluarKamis = temp[i].istirahatKeluar
                            this.unix4 = temp[i].unix
                        }  else if(temp[i].hari == '5') {
                            this.jamMasukJumat = temp[i].kerjaMasuk
                            this.jamKeluarJumat = temp[i].kerjaKeluar
                            this.istirahatMasukJumat = temp[i].istirahatMasuk
                            this.istirahatKeluarJumat = temp[i].istirahatKeluar
                            this.unix5 = temp[i].unix
                        }  else if(temp[i].hari == '6') {
                            this.jamMasukSabtu = temp[i].kerjaMasuk
                            this.jamKeluarSabtu = temp[i].kerjaKeluar
                            this.istirahatMasukSabtu = temp[i].istirahatMasuk
                            this.istirahatKeluarSabtu = temp[i].istirahatKeluar
                            this.unix6 = temp[i].unix
                            this.checkSabtu = 1
                            this.disSabtu = false
                        }  else if(temp[i].hari == '7') {
                            this.jamMasukMinggu = temp[i].kerjaMasuk
                            this.jamKeluarMinggu = temp[i].kerjaKeluar
                            this.istirahatMasukMinggu = temp[i].istirahatMasuk
                            this.istirahatKeluarMinggu = temp[i].istirahatKeluar
                            this.unix7 = temp[i].unix
                            this.checkMinggu = 1
                            this.disMinggu = false
                        }
                    }
                } else {
                    this.errorMessage = response.message
                }
            })

            this.moving()
        },

        /**
         * VALIDATE
         */
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.goSave()
                this.loading = true
            }
        },
        submitFormEdit() {
            this.goSaveEdit()
            this.loading = true
        },

        /**
         * CHECK
         */
        saturday() {
            let sabtu = document.getElementById("sabtu")
            if(sabtu.checked == true) {
                this.disSabtu = false
            } else {
                this.disSabtu = true
            }
        },
        sunday() {
            let minggu = document.getElementById("minggu")
            if(minggu.checked == true) {
                this.disMinggu = false
            } else {
                this.disMinggu = true
            }
        },

        /**
         * SETTING
         */
        goSetting() {
            this.dataSetting = []
            DataApi.post('jam_kerja/setting/lihat')
            .then( res => {
                let response = res.data
                if(response.success) {
                    this.$refs.dialog.openModal(response.data)
                } else {
                    this.alertMess = response.message
                    this.success = false
                    this.currentAlertCounter = 7
                }
            })
        },
        goSaveSetting(value) {
            let payload = {
                isFlexible: value.isFlexible,
                isIstirahat: value.isIstirahat,
                isLembur: value.isLembur,
                toleransi: value.toleransi,
                unix: value.unix,
                isLeave: value.isLeave,
                isDinasHoliday: value.isDinasHoliday
            }
            DataApi.post('jam_kerja/setting/simpan', payload)
            .then( res => {
                let response = res.data
                if(response.success) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                        this.alertMess = response.data.Data2
                    } else {
                        this.success = false
                        this.alertMess = response.data.Data2
                    }
                } else {
                    this.success = false
                    this.alertMess = response.message
                }
                this.$refs.dialog.closeModal()
                this.currentAlertCounter = 7
            })
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
    }
}
</script>
<style scoped>
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}

.btn-delete {
    border-radius: 4px;
    float: right;
    width: 160px;
    margin-left: 4px;
    border: 1px solid 	#DC143C;
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-delete:hover {
    border-radius: 4px;
    float: right;
    width: 160px;
    margin-left: 4px;
    border: 1px solid 	#DC143C;
    background-color: 	#DC143C;
    color: white;
}

.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}

.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
</style>